import { Component, ViewEncapsulation } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { MatCalendar, MatCalendarCellClassFunction } from '@angular/material/datepicker';

@Component({
  selector: 'calendar',
  templateUrl: 'calendar.modal.html',
  styleUrls: ['calendar.modal.scss'],
  standalone: true,
  imports: [IonicModule, MatCalendar],
  encapsulation: ViewEncapsulation.None,
})
export class CalendarModal {
  title: string;
  selectedDate: Date;
  minDate: Date;
  maxDate: Date;
  highlightedDates: string[] = [];

  constructor(private modalController: ModalController) {}

  async close(): Promise<void> {
    await this.modalController.dismiss();
  }

  async selectedChanged($event: any): Promise<void> {
    await this.modalController.dismiss($event);
    this.selectedDate = new Date($event);
  }

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate: Date, view: 'month' | 'year' | 'multi-year'): string => {
    if (view === 'month') {
      return this.highlightedDates.some(
        (highlightedDate) => new Date(highlightedDate).toDateString() === cellDate.toDateString()
      )
        ? 'highlighted-dates'
        : '';
    }
    return '';
  };
}
